import apiClient from '@/apiClient';

export default {
  state: () => ({
    currentStep: 0,
    isComplete: false,
    steps: [
      {
        id: 0,
        route: 'home',
        isComplete: false
      },
      {
        id: 1,
        route: 'orders',
        isComplete: false
      },
      {
        id: 2,
        route: 'clients',
        isComplete: false
      },
      {
        id: 3,
        route: 'account',
        isComplete: false
      },
      {
        id: 4,
        route: 'payments',
        isComplete: false
      },
      {
        id: 5,
        route: 'constructors.constructor',
        constructorId: 1,
        isComplete: false
      },
      {
        id: 6,
        route: 'constructors.constructor.prices',
        constructorId: 1,
        isComplete: false
      },
      {
        id: 7,
        route: 'constructors.constructor.branding',
        constructorId: 1,
        isComplete: false
      },
      {
        id: 8,
        route: 'constructors.constructor.notifications',
        constructorId: 1,
        isComplete: false
      },
      {
        id: 9,
        route: 'constructors.constructor.install',
        constructorId: 1,
        isComplete: false
      }
    ]
  }),

  getters: {
    getTutorialStepByRoute: state => routeName => {
      return state.steps.find(step => step.route === routeName);
    },

    getTutorialStepById: state => id => {
      return state.steps.find(step => step.id === id);
    },

    getTutorialNextStep: state => {
      return state.steps.find(step => step.isComplete !== true);
    },

    getTutorialStepsCount: state => {
      return state.steps.length;
    },

    getTutorialStepsPassed: state => {
      return state.steps.filter(step => step.isComplete === true).length;
    }
  },

  actions: {
    completeTutorialStepById({ commit, state }, id) {
      commit('setTutorialStepStatus', {
        id,
        status: true
      });
    },

    completeAllTutorialSteps({ commit, state }) {
      state.steps.forEach(step => {
        commit('setTutorialStepStatus', {
          id: step.id,
          status: true
        });
      });
    },

    skipTutorial({ dispatch }) {
      dispatch('completeAllTutorialSteps');
    },

    completeTutorial({ commit, dispatch }) {
      dispatch('completeAllTutorialSteps').then(() => {
        commit('setTutorialCompleteStatus', true);
        new Promise((resolve, reject) => {
          apiClient
            .patch('/user/stats', {
              firstLoginWizardShow: true
            })
            .then(resp => {
              resolve(resp);
            })
            .catch(err => {
              console.error(err);
              reject(err);
            });
        });
      });
    }
  },

  mutations: {
    setTutorialStepStatus(state, payload) {
      const step = state.steps.find(step => step.id === payload.id);
      if (step !== undefined) {
        step.isComplete = payload.status;
      }
    },

    setTutorialCompleteStatus(state, status) {
      state.isComplete = status;
    }
  }
};
